import { IsString } from 'class-validator';

export class PaymentIntentWithConnectDto {
  @IsString()
  paymentIntentId: string;

  @IsString()
  stripeConnectAccountId?: string;
}
